import React from 'react';
import './LoaderOverlayComponent.css';

function LoaderOverlayComponent(props){
    return (
        <div className="main-wrapper-animation loading-overlay">
            <div className="eclipse">
                <div className="sun"></div>
                <div className="moon"></div>
            </div>
        </div>
    )
}

export default LoaderOverlayComponent;